import { connect } from 'react-redux';
import { injectIntl } from "react-intl";
import ChargeStatisticsComponent from './ChargeStatistics';

export const ChargeStatistics = connect(
    () => {
        return (state: any, props) => ({
            getStatsPending: state.chargeAnalysis.getStats.pending,
            stats: state.chargeAnalysis.stats,
        });
    }
)(injectIntl(ChargeStatisticsComponent));